import { ItfEcoCartCouponItem, ItfCouponGift } from './comps/EcoCartCoupon/type.d';
import { fetchGetWeb, fetchPostWeb } from 'eco-design-micro/request2/FetchClient';
import { API_COUPON_LIST, API_USER_CART_PAGE, API_USER_INFO, API_USER_CART_CHANGE, API_USER_CART_INCREASE, API_USER_CART_MERGE } from './api';
import { ItfEcoCartItemChange, ItfEcoCartItemInit } from './type.d';

// 登录态 - 用户， 将数据存储至后端数据库
// 查询用户优惠券/礼品卡
export const API_GET_COUPON_GIFT = async (params: ItfCouponGift, locale: string): Promise<ItfEcoCartCouponItem> => {
    let data: ItfEcoCartCouponItem = {} as ItfEcoCartCouponItem;
    try {
        const res = await fetchPostWeb(API_COUPON_LIST, params, {
            locale,
            needToken: true,
        });
        if (res?.code === '0') {
            if (res?.data?.coupons?.length > 0) {
                data = res?.data?.coupons[0] as ItfEcoCartCouponItem;
            }
        } else {
            console.error(res?.message);
        }
    } catch (e) {
        console.error(e);
    } finally {
        return data;
    }
};

// 查询用户
export const API_GET_USER_INFO = async (token: string, locale: string) => {
    let data = null;
    try {
        const res = await fetchGetWeb(API_USER_INFO, null, {
            locale,
            token,
        });
        if (res?.code === '0') {
            data = res?.data;
        } else {
            console.error(res?.message);
        }
    } catch (e) {
        console.error(e);
    } finally {
        return data;
    }
};

// 查询用户购物车
export const API_PAGE_USER_CART = async (locale: string): Promise<ItfEcoCartItemInit[]> => {
    let data: ItfEcoCartItemInit[] = [];
    try {
        const res = await fetchGetWeb(
            API_USER_CART_PAGE,
            {},
            {
                locale,
                needToken: true,
            },
        );
        data = (res?.data?.content as ItfEcoCartItemInit[]) || ([] as ItfEcoCartItemInit[]);
    } catch (e) {
        console.error(e);
    } finally {
        return data;
    }
};

// 购物车增加 - quantity传参为增量
export const API_INCREASE_USER_CART = async (params: { productList: ItfEcoCartItemChange[] }): Promise<void> => {
    if (typeof window === 'undefined') return;
    try {
        const locale = window?.location?.pathname?.split('/')?.[1] || 'us';
        await fetchPostWeb(API_USER_CART_INCREASE, params, {
            locale,
            needToken: true,
        });
    } catch (e) {
        console.error(e);
    }
};

// 购物车变动（减少，删除） - quantity传参为全量
export const API_UPDATE_USER_CART = async (params: { productList: ItfEcoCartItemChange[] }): Promise<void> => {
    if (typeof window === 'undefined') return;
    try {
        const locale = window?.location?.pathname?.split('/')?.[1] || 'us';
        await fetchPostWeb(API_USER_CART_CHANGE, params, {
            locale,
            needToken: true,
        });
    } catch (e) {
        console.error(e);
    }
};

// 登录时合并购物车（将游客储存至localstorage的购物车和用户已有的购物车数据合并）
export const API_MERGE_USER_CART = async (params: { productList: ItfEcoCartItemChange[] }, locale: string): Promise<ItfEcoCartItemInit[]> => {
    let data: ItfEcoCartItemInit[] = [];
    try {
        const res = await fetchPostWeb(API_USER_CART_MERGE, params, {
            locale,
            needToken: true,
        });
        data = (res?.data?.content as ItfEcoCartItemInit[]) || ([] as ItfEcoCartItemInit[]);
    } catch (e) {
        console.error(e);
    } finally {
        return data;
    }
};
